/* eslint-disable */
import { OBJECTS_TYPE_OPTIONS } from '@/utils/configs/objectsTypesConfig';

import { createStore } from 'vuex';
import axios from 'axios';

import specifications from '@/store/specifications';
import { convertDataToDbView } from '@/utils/storeUtils';
import { checkIsType } from '@/utils/createHelpers/prepareClasses';

import api from '@/api';

// ----------------------------------- NEW API DATA AND HELPERS ------------------------------------------

// ---------- API data for server ----------------------------

const API_PREFIX = process.env.VUE_APP_API_PREFIX;
const IMAGE_PREFIX = process.env.VUE_APP_IMAGE_PREFIX;

// ---------------------------------------------------------------------

function ApiError(obj) {
  this.code = obj.status; // 422
  this.name = obj.statusText; // 'Unprocessable Entity'
  this.message = '';

  Object.keys(obj.data.errors).forEach((key) => {
    this.message += ` ${key}: ${obj.data.errors[key].join(', ')}`;
  });
}

function convertSchemaItemData(item) {
  // Логика для чистки наименований от лэйбла разделов
  let schemaItemName = item.name;

  if (schemaItemName.includes('-pseudo')) {
    schemaItemName = schemaItemName.replace(/\d+-pseudo/, '');
  }

  return {
    name: schemaItemName, //item.name
    section_index: item.sectionIndex,
    position: item.position,
    terminal_node: item.terminalNode ? item.terminalNode : false,
    document_id: item.docId,
    parent_id: item.parentId,
  };
}
async function writeBranchToDb(root, arr) {
  const res = await api.external.sections.create(convertSchemaItemData(root));

  const childes = arr.filter((item) => item.parentIndex === root.sectionIndex);

  root.secId = res.data.id;

  for (let i = 0; i < childes.length; i++) {
    childes[i].parentId = root.secId;
    childes[i].position = i;
    if (childes[i].terminalNode) {
      const innerRes = await api.external.sections.create(convertSchemaItemData(childes[i]));

      childes[i].secId = innerRes.data.id;

      continue;
    }
    await writeBranchToDb(childes[i], arr);
  }
}

// -------------------------------------------------------------------------------------------------------

function setNullObjects() {
  let nullObjs = [];

  OBJECTS_TYPE_OPTIONS.forEach((obj) => {
    nullObjs.push({
      value: obj.value,
      label: obj.label,
    });
  });

  return nullObjs;
}

const NULL_SCHEMA_SEARCH_DATA = {
  levelsData: [],
};

const NULL_FILE_INFO = {
  timeStamp: '',
  schemaSearchData: JSON.parse(JSON.stringify(NULL_SCHEMA_SEARCH_DATA)),
  objects: JSON.parse(JSON.stringify(setNullObjects())),
};

const NULL_BLOCK_MODE = {
  active: false,
};

const store = createStore({
  modules: {
    specifications,
  },

  state: {
    filters: {
      requirement: null,
      class: null,
    },
    apiParams: {
      prefix: API_PREFIX,
      imagePrefix: IMAGE_PREFIX,
    },
    classifierParams: {
      KSI: '18',
      OLD_KSI: '17',
      MSSK: '5',
    },
    defaultClassifiers: {
      main: '18',
      addition: '17',
    },

    markupFilesList: [],
    createFilesList: [],
    fileName: '',
    fileInfo: JSON.parse(JSON.stringify(NULL_FILE_INFO)),
    currStep: 0,
    lastStep: 0,
    undoStep: 0,
    redoStep: 0,
    currStage: 'selection', // || 'schema' || 'objects'
    currObj: {
      value: 'addon',
      label: 'Приложение',
    },
    blockMode: JSON.parse(JSON.stringify(NULL_BLOCK_MODE)),
    saveBlock: true,
    schemaData: null,
    notUniqueSchema: false,

    docData: {},
    imageFiles: null,
    docsList: [],
    docUnique: true,

    currEditor: null,
    currLicense: null,

    // ---------------------- NEW API BASED ---------------------
    docsSelected: [],

    verifiedReqs: [],
    verifiedReqClasses: [],
    verifiedReqFeatures: [],
    autoSelectedClasses: [],
    handledAutoClasses: [],
    notDefinedCodes: [],
    currReqClasses: [],
    verifiedDocSections: [],

    authError: null,
    redirectPage: null,

    // PROJECT API
    projectDocs: null,
    idProjectDoc: null,
    projectStyles: null,
  },

  getters: {
    apiParams: (state) => ({ ...state.apiParams }),
    classifierParams: (state) => ({ ...state.classifierParams }),
    getDefaultClassifiers: (state) => (key) => state.defaultClassifiers[key],

    currImageFiles: (state) => state.imageFiles,

    serverMarkupFilesNames: (state) => state.markupFilesList.map((i) => ({ ...i })),
    currFileName: (state) => state.fileName,
    currFileInfo: (state) => JSON.parse(JSON.stringify(state.fileInfo)),
    currFileCurrStep: (state) => state.currStep,
    currLastStep: (state) => state.lastStep,
    schemaSearchData: (state) => JSON.parse(JSON.stringify(state.fileInfo.schemaSearchData)),
    activeObject: (state) => {
      let activeObject = '';

      Object.keys(state.fileInfo.objects).forEach((key) => {
        if (state.fileInfo.objects[key].isActive) activeObject = key;
      });

      return activeObject;
    },
    blockMode: (state) => Object.assign({}, state.blockMode),
    saveBlock: (state) => state.saveBlock,
    processedLevels: (state) => {
      // let text = state.fileInfo.schemaSearchData.levelsData
      // 	.map(i => i.objLabel)
      // 	.join(', ')

      // return text? text: 'Нет обработанных уровней'
      if (!state.schemaData) {
        return [];
      } else {
        let schemaLvls = state.schemaData.map((item) => item.level);
        let setLevels = new Set(schemaLvls);
        return Array.from(setLevels);
      }
    },
    processStage: (state) => state.currStage,
    proceedingObject: (state) => state.currObj,
    documentObjects: (state) => state.fileInfo.objects,
    schemaData: (state) => state.schemaData,
    notUniqueSchema: (state) => state.notUniqueSchema,

    isDocUnique: (state) => state.docUnique,
    docsList: (state) =>
      state.docsList.map((i) => {
        return {
          value: +i.id,
          label: i.name,
          index: i.index,
          isList: i.isList,
        };
      }),
    docNameById: (state) => (id) => {
      let doc = state.docsList.find((i) => i.id === id);

      return doc ? doc.name : '';
    },
    currEditor: (state) => state.currEditor,

    // ---------------------- NEW API BASED ---------------------
    currDocsSelected: (state) => state.docsSelected.map((i) => ({ ...i })),
    currListsDocs: (state) =>
      state.docsSelected
        .filter((i) => i.list)
        .map((i) => {
          const fullName = `${i.index} от ${i.approvedDate}. ${i.name}`;

          return {
            value: i.id,
            label: fullName, //.length > 50? `${fullName.slice(0, 47)}...`: fullName,
            name: fullName,
          };
        }),
    currDocData: (state) => Object.assign({}, state.docData),
    currVerifiedReqs: (state) => state.verifiedReqs,
    displayCurrVerifiedReqs: (state) => {
      if (state.filters.class) {
        const reqIds = state.notDefinedCodes
          .filter((item) => {
            const part = state.filters.class.split('>');
            const section = part[0];
            const code = part[1];
            return item.section === section && item.code === code;
          })
          .map((item) => item.reqId);
        return state.verifiedReqs.filter((item) => reqIds.includes(item.id));
      } else if (state.filters.requirement) {
        return state.verifiedReqs.filter((item) => state.filters.requirement === item.id);
      } else {
        const reqIds = state.notDefinedCodes.map((item) => item.reqId);
        return state.verifiedReqs.filter((item) => reqIds.includes(item.id));
      }
    },
    currVerifiedReqClasses: (state) => state.verifiedReqClasses,
    currHandledAutoClasses: (state) => state.handledAutoClasses,
    currNotDefinedCodes: (state) => state.notDefinedCodes,
    displayCurrNotDefinedCodes: (state) => {
      if (state.filters.class) {
        return state.notDefinedCodes.filter((item) => {
          const part = state.filters.class.split('>');
          const section = part[0];
          const code = part[1];
          return item.section === section && item.code === code;
        });
      } else if (state.filters.requirement) {
        return state.notDefinedCodes.filter((item) => {
          return item.reqId === state.filters.requirement;
        });
      } else {
        return state.notDefinedCodes;
      }
    },
    currVerifiedReqFeatures: (state) => state.verifiedReqFeatures,
    currReqClasses: (state) => state.currReqClasses,
    currDocSectionById: (state) => (id) => {
      let section = state.verifiedDocSections.find((i) => i.id === id);
      return section ? section.name : 'Элемент схемы не определен';
    },
    getAuthError: (state) => state.authError,
    currRedirectPage: (state) => state.redirectPage,
    currLicense: (state) => state.currLicense,

    // PROJECT
    currProjectPage: (state) => state.projectDocs,
    currProjectDoc: (state) => state.idProjectDoc,
    currProjectStyles: (state) => state.projectStyles,
  },

  mutations: {
    SET_MARKUP_FILES_LIST(state, arr) {
      state.markupFilesList = arr.map((i) => ({ ...i }));
    },
    REMOVE_FILE_NAME_FROM_MARKUP_LIST(state) {
      state.markupFilesList.splice(
        state.markupFilesList.findIndex((i) => i.toString() === state.fileName.toString()),
        1
      );
    },
    SET_FILE_NAME(state, str) {
      state.fileName = str;
    },
    SET_FILE_INFO(state, obj) {
      if (Object.hasOwn(obj, 'mode')) {
        state.fileInfo = obj.docInfo;
        state.currStage = obj.mode;
        state.currObj = obj.proceedingObject;
        state.schemaData = obj.schemaData || null;
      } else {
        // Отработка для ранее созданных документов
        state.fileInfo = obj;
        state.schemaData = null;
      }
    },
    SET_CURR_STEP(state, num) {
      state.currStep = num;
    },
    SET_LAST_STEP(state, num) {
      state.lastStep = num;
    },
    CHANGE_CURR_STEP(state, num) {
      let newStep = state.currStep + num;

      state.currStep = newStep;
    },
    SET_TIME_STAMP(state) {
      state.fileInfo.timeStamp = Date.now();
    },
    SET_SAVE_BLOCK(state, bool) {
      state.saveBlock = bool;
    },
    SET_CURRENT_STAGE(state, stage) {
      state.currStage = stage;
    },
    SET_CURR_OBJECT(state, value) {
      let currObj = state.fileInfo.objects.findIndex((obj) => obj.value === value);

      state.currObj =
        currObj === -1
          ? {
              label: state.fileInfo.objects[0].label,
              value: state.fileInfo.objects[0].value,
            }
          : {
              label: state.fileInfo.objects[currObj].label,
              value: state.fileInfo.objects[currObj].value,
            };
    },

    SET_DOC_UNIQUE(state, flag) {
      state.docUnique = !flag.exist;
    },

    SET_CURRENT_SESSION_EDITOR(state, obj) {
      if (obj) {
        state.currEditor = {
          email: obj.email,
          id: obj.id,
          name: obj.name,
          license: obj.licenses.map((item) => item.id),
        };
        state.currLicense = obj.license.id;
      } else {
        state.currEditor = obj;
        state.currLicense = obj;
      }
    },

    UPDATE_DOC_STATUS(state, status) {
      state.fileInfo.status = status;
    },
    UPDATE_BLOCK_MODE(state, obj) {
      if (!obj) {
        state.blockMode = { ...NULL_BLOCK_MODE };
      } else {
        state.blockMode.active = true;
      }
    },
    SET_SCHEMA(state, data) {
      if (data) {
        state.schemaData = data.sort((a, b) => a.id - b.id);
      } else {
        state.schemaData = data;
      }
    },
    MODIFY_SCHEMA_ELEMENT(state, el) {
      let ind = state.schemaData.findIndex((item) => item.id === el.id);

      if (ind >= 0) {
        state.schemaData[ind] = el;
      }
    },
    REMOVE_SCHEMA_ELEMENT(state, id) {
      state.schemaData = state.schemaData.filter((el) => el.id !== id);
    },
    SET_UNIQUE_SCHEMA(state, bool) {
      state.notUniqueSchema = bool;
    },
    SET_DOCS_LIST(state, arr) {
      state.docsList = arr;
    },

    // ---------------------- NEW API BASED ---------------------
    SET_DOCS_SELECTED(state, arr) {
      state.docsSelected = arr.map((i) => ({
        name: i.name,
        id: i.id,
        index: i.index_name,
        approvedDate: i.published_at,
        state: i.state,
        list: i.list,
        license: i.license_id,
        status: i.status,
        user: i.user_id,
        note: i.note,
      }));
    },
    SET_DOC_DATA(state, obj) {
      // FROM OLD VERSION
      state.docData = { ...obj };
    },
    UPDATE_DOC_NOTE_DATA(state, value) {
      state.docData.note.description = value;
    },
    DELETE_DOC_FROM_LIST(state, id) {
      state.docsSelected.splice(
        state.docsSelected.findIndex((i) => i.id === id),
        1
      );
    },

    SET_VERIFIED_REQS(state, arr) {
      state.verifiedReqs = arr.sort(function (a, b) {
        // return (a['document_section_id'] - b['document_section_id'] || a['position'] - b['position'])
        return a['id'] - b['id'];
      });
    },
    // TODO: убрать actions, проверка по classifierId более не нужна
    SET_VERIFIED_REQ_CLASSES(state, { params, action }) {
      switch (action) {
        case 'add':
          params.forEach((item) => {
            state.verifiedReqClasses.push(item);
          });
          break;
        case 'clear':
          state.verifiedReqClasses = params;
          break;
      }
    },
    SET_HANDLED_AUTO_CLASSES(state, { params, action }) {
      switch (action) {
        case 'add':
          state.handledAutoClasses.push(params);
          break;
        case 'clear':
          state.handledAutoClasses = params;
          break;
      }
    },
    SET_VERIFIED_REQ_FEATURES(state, { params, action }) {
      switch (action) {
        case 'add':
          // Пушим найденное значение в массив значений
          state.verifiedReqFeatures.push(params);
          break;
        case 'update':
          /**
           * Для всех обновлений параметров значений используется кейс update
           * Тк мы передаем разные поля, одновременно проверяем все возможные приходы
           * Если в params есть соответствующий ключ - в рассматриваемом итеме принимаем значение по params
           * Иначе оставляем текущее в state значение
           */
          state.verifiedReqFeatures[params.index].classCode = params.classCode
            ? params.classCode
            : state.verifiedReqFeatures[params.index].classCode;
          state.verifiedReqFeatures[params.index].className = params.className
            ? params.className
            : state.verifiedReqFeatures[params.index].className;
          state.verifiedReqFeatures[params.index].featureCode = params.featureCode
            ? params.featureCode
            : state.verifiedReqFeatures[params.index].featureCode;
          state.verifiedReqFeatures[params.index].featureName = params.featureName
            ? params.featureName
            : state.verifiedReqFeatures[params.index].featureName;
          state.verifiedReqFeatures[params.index].newClassId = params.newClassId
            ? params.newClassId
            : state.verifiedReqFeatures[params.index].newClassId;
          state.verifiedReqFeatures[params.index].newFeatureId = params.newFeatureId
            ? params.newFeatureId
            : state.verifiedReqFeatures[params.index].newFeatureId;
          state.verifiedReqFeatures[params.index].valueType = params.valueType
            ? params.valueType
            : state.verifiedReqFeatures[params.index].valueType;
          state.verifiedReqFeatures[params.index].table = params.table
            ? params.table
            : state.verifiedReqFeatures[params.index].table;

          break;
        case 'remove':
          state.verifiedReqFeatures.splice(params, 1);
          break;
        case 'clear':
          state.verifiedReqFeatures = params;
          break;
      }
    },
    SET_NOT_DEFINED_CODES(state, { params, action }) {
      switch (action) {
        // Добавление итемов к массиву необработанных кодов
        case 'add':
          state.notDefinedCodes.push(params);
          break;
        // Исключение обработанных классов
        case 'update':
          state.notDefinedCodes = state.notDefinedCodes.filter(
            (item) => !(item.code === params.code && item.section === params.section)
          ); //item.newClassId !== params
          break;
        // Удаление обработанного кода из массива необработанных
        case 'remove':
          state.notDefinedCodes.splice(params, 1);
          break;
        // Очистка массива необработанных кодов
        case 'clear':
          state.notDefinedCodes = params;
          break;
      }
    },

    SET_CURR_REQ_CLASSES(state, arr) {
      state.currReqClasses = arr;
    },

    SET_CURR_DOC_SECTIONS(state, obj) {
      state.verifiedDocSections = obj.sections;
    },

    SET_CLASSIFIER(state, obj) {
      state.classifierParams[obj.classifier] = obj.id;
    },
    SET_AUTH_ERROR(state, msg) {
      state.authError = msg;
    },
    SET_REDIRECT_PAGE(state, page) {
      state.redirectPage = page;
    },

    SET_PROJECT_DOCS(state, arr) {
      state.projectDocs = arr;
    },

    SET_PROJECT_DOC_ID(state, id) {
      state.idProjectDoc = id;
    },

    SET_PROJECT_STYLES(state, arr) {
      state.projectStyles = arr;
    },

    SET_IMAGE_FILES(state, data) {
      state.imageFiles = data;
    },
  },

  actions: {
    setClassifier({ commit }, obj) {
      commit('SET_CLASSIFIER', obj);
    },
    startObjectsMarkup({ commit }) {
      commit('SET_CURR_OBJECT', 'addon');
    },

    async setSessionEditor({ commit }, data) {
      commit('SET_CURRENT_SESSION_EDITOR', data);
    },

    // -------------------------------- NEW API --------------------------------
    async checkIsDocUnique({ commit }, { index, approvedDate }) {
      const dateApproved = approvedDate.toLocaleDateString('ru').split('.').reverse().join('-');

      try {
        const res = await api.external.documents.check({
          index_name: index,
          published_at: dateApproved,
        });

        commit('SET_DOC_UNIQUE', res.data);
      } catch (err) {
        throw err;
      }
    },

    resetDocUniqueFlag({ commit }, flag) {
      commit('SET_DOC_UNIQUE', flag);
    },
    async getDocumentData({ commit }, id) {
      try {
        const res = await api.external.documents.get(id);
        commit('SET_DOC_DATA', res.data);
      } catch (err) {
        throw err;
      }
    },
    async saveDocumentData({ commit }, data) {
      data.start_at = data.start_at.toLocaleDateString('ru').split('.').reverse().join('-');
      data.published_at = data.published_at.toLocaleDateString('ru').split('.').reverse().join('-');
      if (data.end_at) data.end_at = data.end_at.toLocaleDateString('ru').split('.').reverse().join('-');

      try {
        const res = await api.external.documents.create(convertDataToDbView(data));

        data.id = +res.data;
        commit('SET_DOC_DATA', data);
      } catch (err) {
        if (err.response) {
          let cond1 = err.response.status === 422;
          let cond2 = err.response.statusText === 'Unprocessable Entity';
          let cond3 = 'errors' in err.response.data;

          if (cond1 && cond2 && cond3) throw new ApiError(err.response);
        } else {
          throw err;
        }
      }
    },
    async saveDocNote({}, data) {
      try {
        await api.external.documents.updateNote(data);
      } catch (error) {
        throw error;
      }
    },
    async updateDocumentData({ commit }, data) {
      try {
        await api.external.documents.update(convertDataToDbView(data));
        commit('SET_DOC_DATA', data);
      } catch (err) {
        console.error('Error on update doc data with: ', err.message);
        throw err;
      }
    },
    async updateDocStatus({ state }, docState) {
      try {
        await api.external.documents.update({
          id: state.docData.id,
          state: docState,
        });
      } catch (err) {
        console.error('Error on update document status: ', err.message);
        throw err;
      }
    },
    async saveSchemaData({}, { fileName, schemaData }) {
      try {
        const trees = [];
        let treeCounter = -1;

        // First pass to divide into trees
        for (let i = 0; i < schemaData.length; i++) {
          const arr = schemaData[i].sectionIndex.split('|');
          const num = arr.length - 1;
          // const secInd = schemaData[i].arr.map(i => `${i.name}_${i.index}`).join('|')

          if (num === 0) {
            treeCounter += 1;
            trees[treeCounter] = [];
          }
          trees[treeCounter].push({
            row: arr,
            name: schemaData[i].name, //`${schemaData[i][num].name} ${schemaData[i][num].index}`,
            sectionIndex: schemaData[i].sectionIndex,
            parentIndex: num ? arr.slice(0, -1).join('|') : null,
            position: num ? null : treeCounter,
            docId: +fileName.split('.')[0].split('_')[1],
          });
        }

        // Second pass to set terminal nodes
        for (let tree of trees) {
          for (let item of tree) {
            if (tree.findIndex((i) => i.parentIndex === item.sectionIndex) === -1) {
              item.terminalNode = true;
            }
          }
        }

        // Third pass is recursive save in DB (to get id to set parentId down)
        for (let tree of trees) {
          await writeBranchToDb(tree[0], tree);
        }
      } catch (err) {
        throw err;
      }
    },
    async clearSchemaData({}, { fileName }) {
      try {
        const docId = +fileName.split('.')[0].split('_')[1];
        await api.external.sections.remove(docId);
      } catch (error) {
        throw error;
      }
    },
    async getDocsData({ commit }) {
      try {
        const res = await api.external.documents.getAll();
        commit('SET_DOCS_SELECTED', res.data.docs);
      } catch (err) {
        console.error('Error on get docs data with: ', err.message);
        throw err;
      }
    },
    setDocumentData({ commit }, obj) {
      commit('SET_DOC_DATA', obj);
    },
    updateDocumentNoteData({ commit }, value) {
      commit('UPDATE_DOC_NOTE_DATA', value);
    },

    // AddClasses
    // TODO: все действия перенести в store/specification/index.js
    // TODO: оптимизировать методы, собрать в схожие структуры в единое целое
    async getVerifiedReqs({ commit }, id) {
      try {
        // TODO: передавать id выбранного документа
        const res = await api.external.requirements.getBySection({ id });
        commit('SET_VERIFIED_REQS', res.data);
      } catch (err) {
        console.log('Error on get verified reqs: ', err.message);
        throw err;
      }
    },
    async getClassFromVerifiedReqs({ state, commit }, id) {
      try {
        let classes = [];
        const res = await api.external.reqClasses.getLinked(id, {
          classifier_id: state.classifierParams['OLD_KSI'],
        });

        classes = res.data.map((i) => ({
          reqId: id,
          section: i.classifiers_table.code,
          code: i.code,
          name: i.name,
          id: i.id,
          classifierId: i.classifier_id,
          descr: i.description,
          withChildren: i.with_children,
          autoSelection: i.auto_selection,
          childrenCount: i.children_list.length,
          parent: i.parent_id,
        }));

        let mainClasses = classes.filter((item) => !item.autoSelection);

        commit('SET_VERIFIED_REQ_CLASSES', {
          action: 'add',
          params: mainClasses,
        });
      } catch (err) {
        console.log('Error on get classes: ', err.message);
        throw err;
      }
    },
    // Привязываем класс к требованию
    async addClassToVerifiedReqs({}, { id, reqId, withChildren, isAuto = false }) {
      try {
        await api.external.reqClasses.create(
          {
            classifiers_class_id: id,
            requirement_id: reqId,
            auto_selection: isAuto,
          },
          {
            with_children: withChildren,
          }
        );
      } catch (err) {
        if (err.response) {
          let cond1 = err.response.data && err.response.data.errors && err.response.data.errors.classifiers_class_id;
          let cond2 = cond1 && err.response.data.errors.classifiers_class_id.includes('уже существует');

          if (cond2) return;
        }
        throw err;
      }
    },

    async checkClassInNewKSI({ state }, item) {
      try {
        const res = await api.external.classes.getByCode({
          classifier: state.classifierParams.KSI,
          table: item.section,
          code: item.code,
        });

        return res.data;
      } catch (error) {
        throw error;
      }
    },

    async addOtherCodeToReq({ state }, { classIndex, classCode }) {
      // Преобразуем строку кодов в массив
      let isHandled = false;
      let noSuchCode = false;

      // Проходим по каждому коду в массиве для его привязки к требованиям
      for (let i = 0; i < classCode.length; i++) {
        try {
          // Привязываем класс по пришедшему id и id требования из исходного класса
          await this.dispatch('addClassToVerifiedReqs', {
            id: classCode[i].class.id,
            reqId: state.notDefinedCodes[classIndex].reqId,
            withChildren: classCode[i].isForAll,
            isAuto: false,
          });

          await this.dispatch('checkAndAddParentClass', {
            code: classCode[i].class.code,
            section: classCode[i].table,
            reqId: state.notDefinedCodes[classIndex].reqId,
            parent: classCode[i].class.parent_id,
          });

          isHandled = true;
        } catch (err) {
          if (err.response) {
            let cond1 = err.response.data && err.response.data.errors && err.response.data.errors.classifiers_class_id;
            let cond2 = cond1 && err.response.data.errors.classifiers_class_id.includes('уже существует');

            if (cond2) {
              isHandled = true;
              continue;
            }
          }
          throw err;
        }
      }

      if (isHandled && !noSuchCode) {
        this.dispatch('removeClassFromNotDefinedCodes', {
          params: classIndex,
          action: 'remove',
        });
      }
    },

    async checkAndAddParentClass({}, { code, section, reqId, parent }) {
      if (!checkIsType(code, section)) return;

      try {
        await this.dispatch('addClassToVerifiedReqs', {
          id: parent,
          reqId,
          withChildren: false,
          isAuto: true,
        });
      } catch (err) {
        if (err.response) {
          let cond1 = err.response.data && err.response.data.errors && err.response.data.errors.classifiers_class_id;
          let cond2 = cond1 && err.response.data.errors.classifiers_class_id.includes('уже существует');

          if (cond2) return;
        }
        throw err;
      }
    },

    // Удаление класса из списка необработанных классов
    removeClassFromNotDefinedCodes({ commit }, obj) {
      commit('SET_NOT_DEFINED_CODES', obj);
    },

    // Получение значений характеристик, привязанных к требованию
    async getFeaturesFromVerifiedReqs({ state, commit }, id) {
      try {
        const res = await api.external.reqFeatures.get(id, {
          classifier_id: state.classifierParams['OLD_KSI'],
        });

        for (let feature of res.data) {
          /**
           * action: string
           * params: {
           * 	reqId: number (requirement_id)
           * 	oldClassId: number (classifier_jump_class_id)
           * 	oldFeatureId: number (classifier_class_id)
           *  table: string (classifiers_table.code)
           * 	newClassId: number (new classifier_jump_class_id)
           * 	newFeatureId: number (new classifier_class_id)
           * 	valueType: string
           * 	classCode: string
           * 	className: string
           * 	featureCode: string
           * 	featureName: string
           * 	relationship: string (relationship_operation)
           * 	measureUnit: number (measure_unit_id)
           * 	valueBool: boolean (bool_value)
           * 	valueString: string (str_value)
           * 	valueList: array (list_value)
           * 	valueNumLow: number (num_low_value)
           * 	valueNumHigh: number (num_high_value)
           * }
           */
          const featureRes = await api.external.classes.getById(feature.classifiers_class_id);

          commit('SET_VERIFIED_REQ_FEATURES', {
            action: 'add',
            params: {
              reqId: feature.requirement_id,
              oldClassId: feature.classifiers_jump_class_id,
              oldFeatureId: feature.classifiers_class_id,
              table: null,
              newClassId: null,
              newFeatureId: null,
              valueType: '',
              classCode: '',
              className: '',
              featureCode: featureRes.data.code,
              featureName: featureRes.data.name,
              relationship: feature.relationship_operation,
              measureUnit: feature.measure_unit_id,
              valueBool: feature.bool_value,
              valueString: feature.str_value,
              valueList: feature.list_value,
              valueNumLow: feature.num_low_value,
              valueNumHigh: feature.num_high_value,
            },
          });
        }
      } catch (err) {
        console.log(`Ошибка получения значений характеристик по требованию ${id}: `, err);
      }
    },

    async getClassInfo({ commit }, { mode, id, index }) {
      try {
        const res = await api.external.classes.getById(id);

        switch (mode) {
          case 'updateClass':
            commit('SET_VERIFIED_REQ_FEATURES', {
              action: 'update',
              params: {
                index: index,
                classCode: res.data.code,
                className: res.data.name,
                table: res.data.classifiers_table.code,
              },
            });
            break;
        }
      } catch (err) {
        console.log('Error in get class info. ', err);
      }
    },
    async getClassByCode({ state, commit }, { mode, code, section, index }) {
      try {
        const res = await api.external.classes.getByCode({
          classifier: state.classifierParams.KSI,
          table: section,
          code,
        });

        // Если нет - прерываем выполнение и выдаем соответствующий Error
        if (!res.data[0]) throw new Error('No such classifier code!');

        switch (mode) {
          case 'updateFeatureId':
            commit('SET_VERIFIED_REQ_FEATURES', {
              action: 'update',
              params: {
                index: index,
                newFeatureId: res.data[0].id,
              },
            });
            break;
          case 'updateClassId':
            commit('SET_VERIFIED_REQ_FEATURES', {
              action: 'update',
              params: {
                index: index,
                newClassId: res.data[0].id,
              },
            });
            break;
        }
      } catch (err) {
        console.log('Error with get class. ', err);
      }
    },

    // Запись значений характеристик
    async setFeaturesByNewClassifier({}, { feature, index }) {
      // Создаем объект со стандартными значениями
      let objData = {
        classifiers_class_id: feature.newFeatureId,
        requirement_id: feature.reqId,
        classifiers_jump_class_id: feature.newClassId,
        measure_unit_id: feature.measureUnit,
        relationship_operation: feature.relationship,
        bool_value: 0,
        str_value: '',
        list_value: [],
        num_low_value: null,
        num_high_value: null,
      };

      // В зависимости от типа характеристики привязываем соответствующее значение
      switch (feature.valueType) {
        case 'numeric':
          objData['num_high_value'] = feature.valueNumHigh;
          objData['num_low_value'] = feature.valueNumLow;
          break;
        case 'string':
          objData['str_value'] = feature.valueString;
          break;
        case 'list':
          objData['list_value'] = feature.valueList;
          break;
        case 'logical':
          objData['bool_value'] = feature.valueBool;
          break;
      }

      // Передаем объект в БД
      try {
        await api.external.reqFeatures.create(objData);
        this.dispatch('removeFeatureFromList', index);
      } catch (err) {
        if (err.response) {
          let cond1 = err.response.data && err.response.data.errors && err.response.data.errors.item;
          let cond2 = cond1 && err.response.data.errors.item.includes('уже существует');

          if (cond2) {
            this.dispatch('removeFeatureFromList', index);
            return;
          }
        }
        throw err;
      }
    },

    removeFeatureFromList({ commit }, index) {
      commit('SET_VERIFIED_REQ_FEATURES', {
        action: 'remove',
        params: index,
      });
    },

    async setCurrentReqClasses({ state, commit }, id) {
      try {
        const res = await api.external.reqClasses.getAll(id, {
          classifier_id: state.classifierParams.KSI,
        });
        const specClasses = [];
        for (let i = 0; i < res.data.classes.length; i++) {
          const innerRes = await api.external.classes.getById(res.data.classes[i]);
          specClasses.push(innerRes.data);
        }
        commit('SET_CURR_REQ_CLASSES', specClasses);
      } catch (err) {
        throw err;
      }
    },

    async saveFeatureToVerifiedReq({}, data) {
      try {
        for (let i = 0; i < data.classifiersJumpClassId.length; i++) {
          const currData = JSON.parse(JSON.stringify(data));
          currData.classifiersJumpClassId = data.classifiersJumpClassId[i];

          await api.external.reqFeatures.create(convertDataToDbView(currData));
        }
      } catch (err) {
        console.error(`Error on write characteristic: ${err.message}`);
        throw err;
      }
    },

    // Получение основного текста требования
    async getReqMainText({}, id) {
      try {
        const res = await api.external.accordions.get(id);

        const mainText = res.data.texts.filter((item) => item.name === null);

        return {
          isError: false,
          text: mainText[0],
        };
      } catch (error) {
        return {
          isError: true,
          text: 'Ошибка при получении текста требования',
        };
      }
    },

    // Получение данных структуры документа
    async setCurrDocSections({ commit }, id) {
      try {
        const res = await api.external.sections.getAll(id);

        commit('SET_CURR_DOC_SECTIONS', res.data);
      } catch (error) {
        console.error(error);
      }
    },

    // -------------------------------------------------------------------------

    async setFilesMarkupList({ state, commit }) {
      try {
        const res = await axios.get(`/api/markupfileslist${state.currLicense ? `?license=${state.currLicense}` : ''}`);
        const idArr = res.data.map((i) => +i.split('_')[1]).filter((i) => !Number.isNaN(i));
        const docArr = [];

        for (let i = 0; i < idArr.length; i++) {
          try {
            const docRes = await api.external.documents.get(idArr[i]);
            docArr.push({
              id: idArr[i],
              name: `doc_${idArr[i]}`,
              data: docRes.data,
            });
          } catch (err) {
            console.log(`No file with id: ${idArr[i]} in DB`);
          }
        }
        commit('SET_MARKUP_FILES_LIST', docArr);
      } catch (err) {
        console.error(err.message);
      }
    },
    setFileName({ commit }, name) {
      commit('SET_FILE_NAME', name);
    },

    removeFileNameFromMarkupList({ commit }) {
      commit('REMOVE_FILE_NAME_FROM_MARKUP_LIST');
    },
    async setNullFileInfo({ state, commit }, fileName) {
      try {
        let fileInfo = JSON.parse(JSON.stringify(NULL_FILE_INFO));

        commit('SET_CURR_STEP', 1);
        commit('SET_LAST_STEP', 1);
        fileInfo.timeStamp = Date.now();
        let response = await fetch(`/api/setnewfileinfo${state.currLicense ? `?license=${state.currLicense}` : ''}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: fileName ? fileName : state.fileName,
            currStep: state.currStep,
            info: JSON.stringify(fileInfo),
          }),
        });

        if (response.ok) {
          commit('SET_FILE_INFO', fileInfo);
        }
      } catch (err) {
        console.error('Cannot set new null file info with:', err);
      }
    },
    setTimeStamp({ commit }) {
      commit('SET_TIME_STAMP');
    },
    async changeCurrStep({ commit }, num) {
      commit('CHANGE_CURR_STEP', num);
    },
    async getCurrentFileInfo({ state, commit }) {
      try {
        let res = await axios.get(
          `/api/fileinfo/${state.fileName}/${state.currStep}${state.currLicense ? `?license=${state.currLicense}` : ''}`
        );

        if (res.data.message === 'metafile') {
          throw new Error('NO CURRENT FILE METADATA!');
        } else {
          commit('SET_FILE_INFO', res.data);
        }
      } catch (err) {
        console.error('Cannot read current file info with:', err.message, err.code);
      }
    },
    async getCurrStep({ state, commit }) {
      try {
        let res = await axios.get(
          `/api/filestep/${state.fileName}${state.currLicense ? `?license=${state.currLicense}` : ''}`
        );

        commit('SET_CURR_STEP', +res.data);
        commit('SET_LAST_STEP', +res.data);
        // commit('SET_PROJECT_STYLES', res.data.styles)
      } catch (err) {
        console.error('Cannot read current step with:', err.message, err.code);
      }
    },
    async getCurrStyles({ state, commit }) {
      try {
        let res = await axios.get(
          `/api/styleinfo/${state.fileName}/${state.currStep}${state.currLicense ? `?license=${state.currLicense}` : ''}`
        );

        commit('SET_PROJECT_STYLES', res.data);
      } catch (error) {
        throw 'Ошибка получения стилей';
      }
    },
    setCurrStep({ commit }, num) {
      commit('SET_CURR_STEP', num);
      commit('SET_LAST_STEP', num);
    },
    setSaveBlock({ commit }, bool) {
      commit('SET_SAVE_BLOCK', bool);
    },

    async deleteDocument({ commit }, id) {
      try {
        await this.dispatch('deleteDoc', id);
        commit('DELETE_DOC_FROM_LIST', id);
      } catch (err) {
        console.error(`Error on going to delete document: ${err.message}`);
        throw err;
      }
    },
    async deleteDoc({}, id) {
      try {
        await api.external.documents.remove(id);
      } catch (err) {
        console.error(`Error on going to delete document: ${err.message}`);
        throw err;
      }
    },
    setSchemaData({ commit }, data) {
      commit('SET_SCHEMA', data);
    },
    modifySchemaElement({ commit }, el) {
      commit('MODIFY_SCHEMA_ELEMENT', el);
    },
    removeSchemaElement({ commit }, id) {
      commit('REMOVE_SCHEMA_ELEMENT', id);
    },
    setUniqueSchema({ commit }, bool) {
      commit('SET_UNIQUE_SCHEMA', bool);
    },
    setCurrentStage({ commit }, stage) {
      commit('SET_CURRENT_STAGE', stage || 'selection');
    },
    setCurrObject({ commit }, value) {
      commit('SET_CURR_OBJECT', value ? value : 'addon');
    },
    updateBlockMode({ commit }, obj) {
      commit('UPDATE_BLOCK_MODE', obj ? obj : undefined);
    },
    setError() {
      //{commit}){
      //TODO: Process server errors!
    },

    async authUser({}, obj) {
      const res = await api.profile.auth({ api_v1_user: obj });
      return res.data;
    },

    async getUserData({ commit }) {
      try {
        let res = await api.profile.getUser();
        commit('SET_CURRENT_SESSION_EDITOR', res.data);
      } catch (error) {
        console.error('Error on get user', error.message);
        return;
      }
    },

    setAuthError({ commit }, msg) {
      commit('SET_AUTH_ERROR', msg);
    },

    setRedirectPage({ commit }, page) {
      commit('SET_REDIRECT_PAGE', page);
    },

    saveProjectDocs({ commit }, arr) {
      commit('SET_PROJECT_DOCS', arr);
    },

    setPojectDoc({ commit }, id) {
      commit('SET_PROJECT_DOC_ID', id);
    },

    setProjectStyles({ commit }, styles) {
      commit('SET_PROJECT_STYLES', styles);
    },

    setImageFiles({ commit }, data) {
      commit('SET_IMAGE_FILES', data);
    },
  },
});

export default store;
